import { Injectable, inject } from '@angular/core';
import { ShiftSettingsGatewayService } from '@wilson/api/gateway';
import { ShiftDrawerMode } from '@wilson/interfaces';
import { catchError, firstValueFrom, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShiftDrawerModeService {
  private readonly shiftSettingsGateway = inject(ShiftSettingsGatewayService);

  fetchIsSimplifiedShiftDrawer(): Promise<boolean> {
    return firstValueFrom(
      this.shiftSettingsGateway.get().pipe(
        map((setting) => setting.shiftDrawerMode === ShiftDrawerMode.Simple),
        catchError(() => of(false)),
      ),
    );
  }
}
